export const LotteryMKTCompanyConst = [
  {
    lotteryUrl: "/image/lotteryCompany/magnum.avif?15648811",
    lotteryCode: "M",
    lotteryKeyCode: "1",
  },
  {
    lotteryUrl: "/image/lotteryCompany/damacai.avif?4843214",
    lotteryCode: "P",
    lotteryKeyCode: "2",
  },
  {
    lotteryUrl: "/image/lotteryCompany/toto.avif?1487456878",
    lotteryCode: "T",
    lotteryKeyCode: "3",
  },
  {
    lotteryUrl: "/image/lotteryCompany/singapore.avif?2484166564",
    lotteryCode: "S",
    lotteryKeyCode: "4",
  },
  {
    lotteryUrl: "/image/lotteryCompany/sabah88.avif?9871415",
    lotteryCode: "B",
    lotteryKeyCode: "5",
  },
  {
    lotteryUrl: "/image/lotteryCompany/cashweep.avif?154656998",
    lotteryCode: "W",
    lotteryKeyCode: "6",
  },
  {
    lotteryUrl: "/image/lotteryCompany/sandakan.avif?97851449846",
    lotteryCode: "K",
    lotteryKeyCode: "7",
  },
];

export const LotteryHLCompanyConst = [
  {
    lotteryUrl: "/image/lotteryCompany/gdlotto.avif?547498325",
    lotteryCode: "H",
    lotteryKeyCode: "8",
  },
  // {
  //   lotteryUrl: "/image/lotteryCompany/nineLotto.png",
  //   lotteryCode: "N",
  //   lotteryKeyCode: "9",
  // },
];
